import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'
import { Icon, Button } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { 
  getDetailDocForExtend,
  getListDocForExtend
} from 'ducks/bgCompany'
import { getVendorContacts } from 'ducks/bankGuarantee'
import {
  requestTypeOptions,
  requestForTypeOptions
} from '../../AttributeData'
import { bgCompanyReportDetailPath } from 'routes'
import { Cont } from './styled'

const RequestForComponent = (props) => {

  const { 
    valueForm,
    vendorOptions, 
    companyOptions,
    customerOptions,
    docForExtendOptions,
    change,
    // props
    isEdit = false,
    onRequestTypeChange=null
  } = props

  const getRequestForOption = () =>{
    let option = []
    if(valueForm.requestForType=='vendor') option = vendorOptions.data
    else option = customerOptions.data
    return option
  }

  const onSelectRequestType = (value) =>{
    if(value=='extend'){
      change('formBGCompanyRequest','isReferenceOriginal',true)
    }else{
      change('formBGCompanyRequest','isReferenceOriginal',false)
    }
  }

  const onRequestForCodeChange = (requestForCode, companyCode) => {
    if (requestForCode && companyCode) {
      props.getVendorContacts(requestForCode, companyCode, onGetVendorContactSuccess)
    }
  }

  const onGetVendorContactSuccess = (data) => {
    let con = []
    data.map((x)=>{
      con.push({
        firstName: x.firstname,
        lastName: x.lastname,
        email: x.email,
        mobile: x.mobile,
        telephone: x.telephone,
        extension: x.extension
      })
    })
    change('formBGCompanyRequest','contacts', con)
  }

  React.useEffect(()=>{
    props.getListDocForExtend(valueForm.companyCode,valueForm.requestForCode)
  },[valueForm.companyCode,valueForm.requestForCode])

  return (
    <StdCard title={<span className='stepTitle'>Request for</span>}>
      <Cont>
        <RowFields>
          <Field 
            name='requestType' 
            label='' 
            type={type.radio}
            options={requestTypeOptions}
            containerStyle={{ marginLeft: '10px' }}
            style={{ marginBottom: '0px' }}
            editable={isEdit}
            horizontalView
            component={FieldInput} 
            specialOnChange={(v)=>{
              onSelectRequestType(v)
              if(onRequestTypeChange)onRequestTypeChange(v)
            }}/>
        </RowFields>
        {valueForm.requestType?
        <RowFields>
          <Field 
            name='companyCode' 
            label='Company'
            require 
            options={companyOptions.data} 
            loading={companyOptions.loading}
            editable={isEdit}
            type={type.select} 
            component={FieldInput} 
            specialOnChange={(value)=>{
              if(valueForm.requestType=='extend'){
                change('formBGCompanyRequest','extendBankGuaranteeId','')
              }
            }}
          />
          <RowFields>
            <Field
              name="requestForType"
              label="Customer/Vendor"
              component={FieldInput}
              options={requestForTypeOptions}
              type={type.select}
              editable={isEdit}
              specialOnChange={(value)=>{
                change('formBGCompanyRequest','requestForCode','')
              }}
              require
            />
            <Field 
              name='requestForCode' 
              label={valueForm.requestForType=='vendor'?'Vendor':'Customer'} 
              require
              options={getRequestForOption()} 
              loading={vendorOptions.loading} 
              editable={isEdit}
              useLazyLoad
              specialOnChange={(value)=>{
                onRequestForCodeChange(value,valueForm.companyCode)
                if(valueForm.requestType=='extend'){
                  change('formBGCompanyRequest','extendBankGuaranteeId','')
                }
              }}
              type={type.select} 
              component={FieldInput} 
            />
          </RowFields>
        </RowFields>:null}
        {valueForm.requestType=='extend'?
        <RowFields>
          <Field
            name="extendBankGuaranteeId"
            label="Bank Guarantee for Extend"
            component={FieldInput}
            options={docForExtendOptions.data}
            type={type.select}
            editable={isEdit}
            className='halfRow'
            specialOnChange={(value)=>{
              props.getDetailDocForExtend(value)
            }}
            require
          />
          {valueForm.extendBankGuaranteeId&&
          <Button size='mini' icon labelPosition='right' className='btnDetail' onClick={()=>window.open(bgCompanyReportDetailPath(valueForm.extendBankGuaranteeId))}>
            BG Company Detail
            <Icon name='right arrow' />
          </Button>}
        </RowFields>:null}
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    customerOptions: state.options.customers,
    docForExtendOptions: state.bgCompany.optionDocForExtend,
  }
}

const mapDispatchToProps = {
  getDetailDocForExtend,
  getListDocForExtend,
  getVendorContacts,
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestForComponent)
